import { DatePicker, Drawer } from 'antd'
import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBarcode,
    faBriefcase,
    faCalendarDays,
    faCar,
    faClock,
    faCreditCard,
    faDroplet,
    faFloppyDisk,
    faGasPump,
    faListDots,
    faMapLocation,
    faMoneyBill,
    faRoad,
    faSign,
    faTachometer,
    faUser,
    faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../../../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { BodyDrawer } from './styled'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { HeaderDrawer } from '../../../../../Components/CustomUi/headerGaveta'
import Input from '../../../../../Components/CustomUi/input'
import { Select } from '../../../../../Components/CustomUi/Select'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import dayjs, { Dayjs } from 'dayjs'
import {
    mascaraAoDigitar,
    mascaraHora,
    mascaraOdometro,
    mascaraValor,
    maskCNPJ,
    removerDecimal,
} from '../../../../../utils'
import AiLoadingOverlay from '../loadingProgress'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import ImageUploader from '../../../../../Components/CustomUi/imgUploader'
import Tabs from '../../../../../Components/Tabs'
import { Render } from '../../../../../Components/CustomUi/render'
import { FornecedorItens } from '../../../../../services/Fornecedores'
import { PropriedadeItens } from '../../../../../services/Propriedades'
import { tabs_local, tabs_responsavel_custo } from '../../meta'
import { Box } from '../../../../../Components/CustomUi/box'
import { combustiveis } from '../../../patrimonioNovo/cadastro/components/gavetaPatrimonio/meta'

interface PropsFormAbastecimento {
    openForm: boolean
    fecharGaveta: Function
    salvarAbastecimento: Function
    carregando_abastecimento: boolean
    update: number
    nome_posto: string
    setNome_posto: React.Dispatch<React.SetStateAction<string>>
    cnpj: string
    setCnpj: React.Dispatch<React.SetStateAction<string>>
    endereco: string
    setEndereco: React.Dispatch<React.SetStateAction<string>>
    odom_atual: string
    setOdom_atual: React.Dispatch<React.SetStateAction<string>>
    qtnd_litros: string
    setQtnd_litros: React.Dispatch<React.SetStateAction<string>>
    valor_total: string
    setValor_total: React.Dispatch<React.SetStateAction<string>>
    forma_pagamento: string
    setForma_pagamento: React.Dispatch<React.SetStateAction<string>>
    setForma_pagamento_id: React.Dispatch<React.SetStateAction<number>>
    tipo_combustivel: string
    setTipo_combustivel: React.Dispatch<React.SetStateAction<string>>
    setTipo_combustivel_id: React.Dispatch<React.SetStateAction<number>>
    data: null | Dayjs
    setData: React.Dispatch<React.SetStateAction<null | Dayjs>>
    hora: string
    setHora: React.Dispatch<React.SetStateAction<string>>
    tanque_cheio: boolean
    setTanque_cheio: React.Dispatch<React.SetStateAction<boolean>>
    usuario_selecionado: string
    setUsuario_selecionado: React.Dispatch<React.SetStateAction<string>>
    setUsuario_selecionado_id: React.Dispatch<React.SetStateAction<number>>
    veiculo_selecionado: string
    setVeiculo_selecionado: React.Dispatch<React.SetStateAction<string>>
    setVeiculo_selecionado_id: React.Dispatch<React.SetStateAction<number>>
    frota: string
    setFrota: React.Dispatch<React.SetStateAction<string>>
    imagePreview: string | null
    // loading_abastecimento_ai: boolean
    handleChangeImage: (file: File, base64?: string) => void
    limparCampos: Function
    data_equipe: any[]
    data_veiculos: any[]
    data_pagamento: any[]
    permissions: ItensPerUserLogged
    /**Define se o abastecimento foi feito em um `Posto` ou em uma `Propriedade` */
    tab_local: string
    selecionarLocal: Function
    posto_selecionado: string
    setPosto_selecionado: React.Dispatch<React.SetStateAction<string>>
    /**Além de guardar o código, preenche os campos do posto automaticamente */
    selecionarPosto: React.Dispatch<React.SetStateAction<number>>
    propriedade_selecionada: string
    setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
    setPropriedade_selecionada_id: React.Dispatch<React.SetStateAction<number>>
    responsavel_custo: string
    setResponsavel_custo: React.Dispatch<React.SetStateAction<string>>
    pagamento_efetuado: boolean
    setPagamento_efetuado: React.Dispatch<React.SetStateAction<boolean>>
    necessario_reembolso: boolean
    setNecessario_reembolso: React.Dispatch<React.SetStateAction<boolean>>
    desconto_folha: boolean
    setDesconto_folha: React.Dispatch<React.SetStateAction<boolean>>
    data_postos: FornecedorItens[]
    data_propriedades: PropriedadeItens[]
    carregando_postos: boolean
    carregando_propriedades: boolean
}

export const FormularioAbastecimento: React.FC<PropsFormAbastecimento> = ({
    openForm,
    fecharGaveta,
    salvarAbastecimento,
    carregando_abastecimento,
    update,
    nome_posto,
    setNome_posto,
    cnpj,
    setCnpj,
    endereco,
    setEndereco,
    odom_atual,
    setOdom_atual,
    qtnd_litros,
    setQtnd_litros,
    valor_total,
    setValor_total,
    forma_pagamento,
    setForma_pagamento,
    setForma_pagamento_id,
    tipo_combustivel,
    setTipo_combustivel,
    setTipo_combustivel_id,
    data,
    setData,
    hora,
    setHora,
    tanque_cheio,
    setTanque_cheio,
    usuario_selecionado,
    setUsuario_selecionado,
    setUsuario_selecionado_id,
    veiculo_selecionado,
    setVeiculo_selecionado,
    setVeiculo_selecionado_id,
    frota,
    setFrota,
    imagePreview,
    // loading_abastecimento_ai,
    handleChangeImage,
    limparCampos,
    data_equipe,
    data_veiculos,
    data_pagamento,
    permissions,
    tab_local,
    selecionarLocal,
    posto_selecionado,
    setPosto_selecionado,
    selecionarPosto,
    propriedade_selecionada,
    setPropriedade_selecionada,
    setPropriedade_selecionada_id,
    responsavel_custo,
    setResponsavel_custo,
    pagamento_efetuado,
    setPagamento_efetuado,
    necessario_reembolso,
    setNecessario_reembolso,
    desconto_folha,
    setDesconto_folha,
    data_postos,
    data_propriedades,
    carregando_postos,
    carregando_propriedades,
}) => {
    const [openSelect, setOpenSelect] = useState<boolean>(false)
    const [openUsuario, setOpenUsuario] = useState<boolean>(false)
    const [openVeiculo, setOpenVeiculo] = useState<boolean>(false)
    const [openForma, setOpenForma] = useState<boolean>(false)
    const [openPosto, setOpenPosto] = useState<boolean>(false)
    const [openPropriedade, setOpenPropriedade] = useState<boolean>(false)

    const em_posto = tab_local === 'Posto'

    function litrosGasolina(valor) {
        setQtnd_litros(mascaraAoDigitar(valor))
    }

    function preencherDadosVeiculo(cod_veiculo) {
        console.log('cod_veiculo', cod_veiculo)
        setVeiculo_selecionado_id(cod_veiculo)
        const veiculo = data_veiculos?.find((item) => item?.cod === cod_veiculo)

        const combustivel = combustiveis?.find((item) => item?.nome === veiculo?.tipo_combustivel)
        console.log('veiculo', veiculo)
        setFrota(veiculo?.frota)
        setTipo_combustivel(combustivel?.nome)
        setTipo_combustivel_id(combustivel?.cod)
        setOdom_atual(removerDecimal(veiculo?.odom_horimetro))
    }

    function selecionarResponsavelCusto(tab: string) {
        setResponsavel_custo(tab)
        if (tab === 'Pessoal') {
            setNecessario_reembolso(false)
            setPagamento_efetuado(false)
        } else if (tab === 'Empresa') {
            setDesconto_folha(false)
            setPagamento_efetuado(false)
        }
    }

    function alternarPagamentoEfetuado(checked: boolean) {
        setPagamento_efetuado(checked)
        if (!checked) {
            setNecessario_reembolso(false)
        } else {
            setDesconto_folha(false)
        }
    }

    return (
        <Drawer
            width={505}
            open={openForm}
            onClose={() => fecharGaveta()}
            closable={false}
            bodyStyle={{ padding: 0 }}
            headerStyle={{ padding: '10px 10px' }}
            destroyOnClose
            footer={
                <div className='footer'>
                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                        type='primary'
                        onClick={salvarAbastecimento}
                        loading={carregando_abastecimento}
                        disabled={carregando_abastecimento || permissions?.alteracao === 0 || permissions?.inclusao === 0}
                    >
                        {update > 0 ? 'Atualizar' : 'Salvar'}
                    </ButtonCustom>
                </div>
            }
            title={
                <NavegacaoDrawer>
                    <ButtonCustom
                        danger
                        icon={<FontAwesomeIcon icon={faXmark} />}
                        type='tertiary'
                        onClick={fecharGaveta}
                        style={{ marginLeft: -10 }}
                    >
                        Fechar
                    </ButtonCustom>
                </NavegacaoDrawer>
            }
        >
            <HeaderDrawer>
                <div>{update > 0 ? 'Atualizar abastecimento' : 'Cadastrar abastecimento'}</div>
            </HeaderDrawer>

            <BodyDrawer>
                <div style={{ position: 'relative' }}>
                    {/* <AiLoadingOverlay isLoading={loading_abastecimento_ai} /> */}

                    <ImageUploader
                        onImageChange={handleChangeImage}
                        width={'100%'} // Largura em pixels
                        height='200px'
                        convertBase64={true}
                        clear={limparCampos}
                        imagePreview={imagePreview}
                        disableDelete={update > 0}
                    />
                </div>

                <Tabs
                    label='Local do abastecimento'
                    tabs={tabs_local}
                    selecionado={tab_local}
                    onChange={selecionarLocal}
                    indexInicial={em_posto ? 0 : 1}
                    trackWidth={226}
                />

                <Select
                    label='Usuário'
                    icon={faUser}
                    placeholder='Selecione o usuário'
                    value={usuario_selecionado}
                    onChange={setUsuario_selecionado}
                    onChangeID={setUsuario_selecionado_id}
                    open={openUsuario}
                    trigger={setOpenUsuario}
                    items={data_equipe}
                    descricaoItem={'usuario_nome'}
                    idItem={'cod_func'}
                />

                <Select
                    label='Veículo'
                    icon={faCar}
                    placeholder='Selecione o veículo'
                    value={veiculo_selecionado}
                    onChange={setVeiculo_selecionado}
                    onChangeID={(cod) => {
                        preencherDadosVeiculo(cod)
                    }}
                    open={openVeiculo}
                    trigger={setOpenVeiculo}
                    items={data_veiculos}
                    descricaoItem={'nome'}
                    idItem={'cod'}
                />

                <Input
                    icon={faBarcode}
                    label='Frota'
                    placeholder='Digite a frota'
                    value={frota}
                    onChange={setFrota}
                />

                <Render condition={em_posto}>

                    <Select
                        label='Posto'
                        icon={faGasPump}
                        placeholder='Selecione o posto'
                        value={posto_selecionado}
                        onChange={setPosto_selecionado}
                        onChangeID={selecionarPosto}
                        open={openPosto}
                        trigger={setOpenPosto}
                        items={data_postos}
                        descricaoItem={'nome'}
                        idItem={'cod'}
                        loading={carregando_postos}
                    />

                    <Input
                        icon={faGasPump}
                        label='Nome posto'
                        placeholder='Digite o nome do posto'
                        value={nome_posto}
                        onChange={setNome_posto}
                    />

                    <Input
                        icon={faBriefcase}
                        label='CNPJ'
                        placeholder='Digite o cnpj'
                        value={maskCNPJ(cnpj)}
                        onChange={setCnpj}
                        maxLength={18}
                    />
                    <Input
                        icon={faRoad}
                        label='Endereço'
                        placeholder='Digite o endereço'
                        value={endereco}
                        onChange={setEndereco}
                    />
                </Render>

                <Render condition={!em_posto}>
                    <Select
                        label='Propriedade'
                        icon={faMapLocation}
                        placeholder='Selecione a propriedade'
                        value={propriedade_selecionada}
                        onChange={setPropriedade_selecionada}
                        onChangeID={setPropriedade_selecionada_id}
                        open={openPropriedade}
                        trigger={setOpenPropriedade}
                        items={data_propriedades}
                        descricaoItem={'nome'}
                        idItem={'cod'}
                        loading={carregando_propriedades}
                    />
                </Render>

                <Input
                    icon={faTachometer}
                    label='Odômetro atual'
                    placeholder='Digite o valor do odômetro atual'
                    value={mascaraOdometro(odom_atual)}
                    onChange={setOdom_atual}
                />

                <Select
                    label='Tipo combustível'
                    icon={faListDots}
                    value={tipo_combustivel}
                    onChange={setTipo_combustivel}
                    onChangeID={setTipo_combustivel_id}
                    open={openSelect}
                    trigger={setOpenSelect}
                    items={combustiveis}
                    descricaoItem={'nome'}
                    idItem={'cod'}
                    placeholder='Selecione o tipo de combustível'
                />

                <Input
                    label='Quantidade de litros'
                    icon={faDroplet}
                    placeholder='Digite a quantidade de litros'
                    value={qtnd_litros}
                    onChange={litrosGasolina}
                />

                <Render condition={em_posto}>
                    <Select
                        label='Forma de pagamento'
                        placeholder='Selecione a forma de pagamento'
                        icon={faCreditCard}
                        value={forma_pagamento}
                        onChange={setForma_pagamento}
                        onChangeID={setForma_pagamento_id}
                        open={openForma}
                        trigger={setOpenForma}
                        items={data_pagamento}
                        descricaoItem={'forma'}
                        idItem={'cod'}
                    />
                </Render>

                <Render condition={em_posto}>
                    <Input
                        label='Valor total'
                        icon={faMoneyBill}
                        placeholder='Digite o valor total'
                        value={mascaraValor(valor_total)}
                        onChange={setValor_total}
                    />
                </Render>

                <div className='campo__dois__inputs'>
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-end',
                        }}
                    >
                        <label
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                fontWeight: 500,
                                color: 'var(--text-color)',
                                display: 'inline-flex',
                                alignItems: 'flex-start',
                                gap: '5px',
                            }}
                        >
                            Data
                        </label>
                        <DatePicker
                            value={data}
                            onChange={setData}
                            format='DD/MM/YYYY'
                            style={{ width: '100%', height: '40px', marginBottom: '2px', borderRadius: '10px' }}
                        />
                    </div>
                    <Input
                        label='Hora'
                        placeholder='Digite a hora'
                        icon={faClock}
                        value={mascaraHora(hora)}
                        onChange={setHora}
                    />
                </div>

                <Render condition={em_posto}>

                    <Switcher label='Tanque cheio?' isChecked={tanque_cheio} trigger={setTanque_cheio} />

                    <Box>
                        <Tabs
                            label='Responsável pelo custo'
                            tabs={tabs_responsavel_custo}
                            selecionado={responsavel_custo}
                            onChange={selecionarResponsavelCusto}
                            indexInicial={responsavel_custo === 'Empresa' ? 0 : 1}
                            trackWidth={215}
                        />

                        <Switcher
                            label='Pagamento já efetuado'
                            isChecked={pagamento_efetuado}
                            trigger={alternarPagamentoEfetuado}
                        />

                        <Render condition={pagamento_efetuado && responsavel_custo === 'Empresa'}>
                            <Switcher
                                label='Reembolso?'
                                isChecked={necessario_reembolso}
                                trigger={setNecessario_reembolso}
                            />
                        </Render>
                        <Render condition={!pagamento_efetuado && responsavel_custo === 'Pessoal'}>
                            <Switcher
                                label='Autoriza desconto em folha?'
                                isChecked={desconto_folha}
                                trigger={setDesconto_folha}
                            />
                        </Render>
                    </Box>
                </Render>


            </BodyDrawer>
        </Drawer>
    )
}